module.exports = __webpack_public_path__ + "static/media/ComercialLine.44fc457f.svg";